import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DeviceFacade } from "@youm-front/device/data-access";
import { tap } from "rxjs/operators";
import { AccountDeviceActions } from "../actions";

@Injectable()
export class AccountDeviceEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly deviceFacade: DeviceFacade
  ) {}

  loadDevices$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AccountDeviceActions.loadDevices),
        tap(() => this.deviceFacade.loadDevices())
      ),
    { dispatch: false }
  );
}
